import ButtonPrimary from '../ButtonPrimary';
import Link from '../Link';
import Typography from '../Typography';
import { GenericErrorIllustration } from './illustrations';

import './GenericError.scss';

const GenericError = () => {
  return (
    <div className="nostra__genericError">
      <GenericErrorIllustration />
      <div className="nostra__genericError__info">
        <Typography variant="heading-sm" weight="medium">
          Something went wrong
        </Typography>
        <Typography variant="body-lg">
          There was an error. Try refreshing the app or contact support through the{' '}
          <Link href="https://discord.gg/zwa8K3drb">Nostra discord</Link>.
        </Typography>
      </div>
      <ButtonPrimary
        onClick={() => {
          location.reload();
        }}
      >
        <Typography variant="button-sm" color="text-primary-darkbg" weight="semi-bold">
          Refresh
        </Typography>
      </ButtonPrimary>
    </div>
  );
};
export default GenericError;
